var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0777 0.656661L1.6227 4.91612C1.24617 5.06952 1 5.43563 1 5.84221V17.6578C1 18.0644 1.24617 18.4305 1.6227 18.5839L12.0956 22.8506C12.3311 22.9466 12.5944 22.9492 12.8318 22.8579L22.859 19.0013C23.2452 18.8527 23.5 18.4817 23.5 18.0679V5.83255C23.5 5.43083 23.2596 5.06811 22.8896 4.91158L12.8447 0.661786C12.5999 0.558216 12.3239 0.556371 12.0777 0.656661Z",
    fill: "none",
    stroke: "#003082"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12268 5.59435L7.36796 7.52403M12.4623 9.83964L21.3774 6.01888M12.4623 9.83964V21.3019M12.4623 9.83964L7.36796 7.52403M7.36796 7.52403L15.8585 3.89624",
    stroke: "#003082",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.00af9c5ac4d05a36cd2e6bd83242f93c.svg";
export { ForwardRef as ReactComponent };